module.exports = __webpack_public_path__ + "static/media/wasabi-round.db5e3fb1.png";